<template>
  <div class="signup app-content">
    <div class="notification-bar" v-if="exam.length != 0">
      <router-link :to="'./examinations'">{{$t("message.add_exam_info_detail")}}</router-link>
    </div>
    <div class="notification-bar" v-if="is_announce">
      <router-link :to="'./accept_certificate'">{{$t("message.regist_result_get_money")}}</router-link>
    </div>

    <div class="bg-gray pb-5">
      <div class="container bg-gray">
        <div class="row pt-lg-3">
        </div>

        <div class="row pb-3">
          <div class="col-9 col-lg-2 pt-2">
            <router-link :to="'./examinations'">
              <div class="row pt-lg-0 pl-3">
                <h5 class="new-text-blue mt-1 pt-1"> {{ $t("message.exam_schedule") }} </h5>
                <b-img src="../../assets/mypage/Scheduled-test-date.svg" style='width: 35px; position: 10px'/>
              </div>
            </router-link>
          </div>

          <div class="col-md-4 col-sm-12 pt-2 pr-0"> 
            <div class="row jobs-row ml-auto">
              <div class="col-md-5 sm-w50 job-columns px-2 mx-2 py-1" style='height: 100%'>
                <router-link :to="'/seeker/resume'">
                <div class="col-12 text-center px-0 py-4">
                  <p class="mb-0"><b-img src="../../assets/mypage/Scheduled-test-date.svg" style='width: 30px;'/>履歴書を作成</p>
                </div>
                </router-link>
              </div>

              <div class="col-md-5 sm-w50 job-columns px-2 mx-2 py-1" style='height: 100%'>
                <a @click="toJobMypage">
                <div class="col-12 text-center px-0 py-4">
                  <p class="mb-0"><b-img src="../../assets/mypage/Scheduled-test-date.svg" style='width: 30px;'/>求人を見る</p>
                </div>
                </a>
              </div>
            </div>
          </div>
          <div class="col-6 d-none d-lg-block pt-2 text-left">
            <div class="row mypage-row-orange mr-lg-1">
              <div class="col-4 mypage-row-orange-columns-start px-0" style='height: 100%'>
                <div class="col-12 mt-2">
                  <div class="row">
                    <div class="col-3 text-center">
                      <b-img src="../../assets/mypage/Scheduled-test-date.svg" style='width: 30px;'/>
                    </div>
                    <div class="col-9 text-center pl-0">
                      <small class="pl-1 small">{{$t("message.industry_id_" + memberInfo.current_industry)}}{{$t("message.of_exam_day")}} </small>
                    </div>
                  </div>
                </div>
                <div class="col-12 text-center py-2">
                  <h3 class="mb-0"><b>{{ format_exam_day() }}</b></h3>
                </div>
              </div>
              <div class="col-4 mypage-row-orange-columns px-0" style='height: 100%'>
                <div class="col-12 mt-2">
                  <div class="row">
                    <div class="col-3 text-center">
                      <b-img src="../../assets/mypage/pass-rate.svg" style='width: 30px; height: 30px'/>
                    </div>
                    <div class="col-9 pl-0">
                      <small class="pl-1 small">{{$t("message.your_estimated_pass_rate")}} </small>
                    </div>
                  </div>
                </div>
                <div class="col-12 text-center py-2">
                    <h3 class="mb-0"><b>{{pass_rate}}<small>%</small></b></h3>
                </div>
              </div>
              <div class="col-4 mypage-row-orange-columns-end px-0" style='height: 100%'>
                <div class="col-12 mt-2">
                  <div class="row">
                    <div class="col-3 text-center">
                      <b-img src="../../assets/mypage/Average-score.svg" style='width: 30px;'/>
                    </div>
                    <div class="col-9 pl-0">
                      <small class="pl-1 small">{{$t("message.your_ave_score")}} </small>
                    </div>
                  </div>
                </div>
                <div class="col-12 text-center py-2">
                    <h3 class="mb-0"><b>{{ave_score}}</b><small>{{$t("message.score")}}</small></h3>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mx-2 pb-3">
          <div class="col-12 d-lg-none mypage-title-row text-center pt-2 pb-2">
            <h4 class="mb-0">{{ $t("message.exam_learning") }} </h4>
          </div>
        </div>
        <div class="row mypage-row mx-2 mx-lg-0">
          <div class="col-2 col-lg-20 d-none  align-items-center mypage-row-columns-title d-lg-flex justify-content-center mypage-row-columns-border">
            <h4 class="mb-0">
              {{ $t("message.exam_learning") }}
            </h4>
          </div>
          <div class="col-6 col-lg-20 mypage-row-columns-border-1 px-0 pb-3">
            <div class="col-12 pl-2 ">
              <b-icon class="h5 mb-0 mt-2" @click='showInfoModal("message.title_help", "message.exam_menu_help")' icon="question-circle" style='color: gray'></b-icon>
            </div>
            <router-link :to="'./quiz'">
              <div class="col-12 text-center pt-0">
                <b-img class='h60-icon' src="../../assets/mypage/solve-an-exam_icon.svg"/>
              </div>
              <div class="col-12 text-center px-1 py-2">
                <p class="mb-0 new-text-blue tight-line-p">{{$t("message.recommend_problem_solve")}}</p>
              </div>
            </router-link>
          </div>
          <div class="col-6 col-lg-20 mypage-row-columns-border-2 px-0 pb-3">
            <div class="col-12 pl-2 ">
              <b-icon class="h5 mb-0 mt-2" @click='showInfoModal("message.title_help", "message.past_menu_help")' icon="question-circle" style='color: gray'></b-icon>
            </div>
            <router-link :to="'./pastedQuizList'">
              <div class="col-12 text-center pt-0">
                <b-img class='h60-icon' src="../../assets/mypage/solve-a-past-exam_icon.svg"/>
              </div>
              <div class="col-12 text-center px-1 py-2">
                <p class="mb-0 new-text-blue tight-line-p">{{$t("message.see_solved_problem")}}</p>
              </div>
            </router-link>
          </div>
          <div class="col-6 col-lg-20 mypage-row-columns-border-3 px-0 pb-3">
            <div class="col-12 pl-2">
              <b-icon class="h5 mb-0 mt-2" @click='showInfoModal("message.title_help", "message.pastexam_menu_help")' icon="question-circle" style='color: gray'></b-icon>
            </div>
            <router-link :to="'./past-exam'">
              <div class="col-12 text-center pt-0">
                <b-img class='h60-icon' src="../../assets/mypage/past-exam-questions.svg"/>
              </div>
              <div class="col-12 text-center px-1 py-2">
                <p class="mb-0 new-text-blue tight-line-p">{{$t("message.past_exam_collection")}}</p>
              </div>
            </router-link>
          </div>
          <div class="col-6 col-lg-20 mypage-row-columns-border-4 px-0 mypage-row-columns-end pb-2">
            <div class="col-12 pl-2">
              <b-icon class="h5 mb-0 mt-2" @click='showInfoModal("message.title_help", "message.text_menu_help")' icon="question-circle" style='color: gray'></b-icon>
            </div>
            <router-link :to="'./study_text'">
              <div class="col-12 text-center pt-0">
                <b-img class='h60-icon' src="../../assets/mypage/education-materials-download.svg"/>
              </div>
              <div class="col-12 text-center px-1 py-2">
                <p class="mb-0 new-text-blue tight-line-p">{{$t("message.mypage_study_text")}}</p>
              </div>
            </router-link>
          </div>
        </div>

        <div class="row mx-2 pb-3 pt-4 d-lg-none ">
          <div class="col-12 mypage-title-row text-center pt-2">
            <h5>{{ $t("message.any_application_registration") }} </h5>
          </div>
        </div>
        <div class="row mx-2 mx-lg-0 mt-lg-4 mt-3">
          <div class="col-12 col-lg-8">
            <div class="row mypage-row mr-lg-1">
              <div class="col-3 d-none align-items-center mypage-row-columns-title d-lg-flex justify-content-center mypage-row-columns-border">
                <h4 class="mb-0">
                {{ $t("message.any_application_registration") }}
                </h4>
              </div>
              <div class="col-12 col-lg-3 mypage-row-columns-border-start-top pb-3">
                <div class="row">
                  <div class="col-2 col-lg-12  pl-2 ">
                    <b-icon class="h5 mb-0 mt-2" @click='showInfoModal("message.title_help", "message.visa_menu_help")' icon="question-circle" style='color: gray'></b-icon>
                  </div>
                  <div class="col-10 col-lg-12 text-center px-0">
                    <router-link :to="'./visa_application'">
                      <div class="row pt-3 pt-lg-0">
                        <div class="col-3 col-lg-12 text-center px-0">
                          <b-img class='h40-icon' src="../../assets/mypage/visa-application.svg"/>
                        </div>
                        <div class="col-9 col-lg-12 text-left text-lg-center pr-3 pt-1">
                          <p class="mb-0 new-text-blue tight-line-p">{{$t("message.mypage_visa_application")}}</p>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-3 mypage-row-columns-border mypage-row-columns-border-2 pb-3">
                <div class="row">
                  <div class="col-2 col-lg-12 pl-2">
                    <b-icon class="h5 mb-0 mt-2" @click='showInfoModal("message.title_help", "message.agency_menu_help")' icon="question-circle" style='color: gray'></b-icon>
                  </div>
                  <div class="col-10 col-lg-12 text-center px-0">
                    <router-link :to="'./examinations'">
                      <div class="row pt-3 pt-lg-0">
                        <div class="col-3 col-lg-12 text-center px-0">
                          <b-img class='h40-icon' src="../../assets/mypage/exam-application.svg"/>
                        </div>
                        <div class="col-9 col-lg-12 text-left text-lg-center pt-lg-2 px-lg-1 pt-1">
                          <p class="mb-0 new-text-blue tight-line-p">{{$t("message.applyt_exam_and_agent")}}</p>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-3 mypage-row-columns-border mypage-row-columns-end-bottom pb-3">
                <div class="row">
                  <div class="col-2 col-lg-12 pl-2 ">
                    <b-icon class="h5 mb-0 mt-2" @click='showInfoModal("message.title_help", "message.cer_menu_help")' icon="question-circle" style='color: gray'></b-icon>
                  </div>
                  <div class="col-10 col-lg-12 text-center px-0">
                    <router-link :to="'./accept_certificate'">
                      <div class="row  pt-3 pt-lg-0">
                        <div class="col-3 col-lg-12 text-center px-0">
                          <b-img class='h40-icon' src="../../assets/mypage/Registration-acceptance.svg"/>
                        </div>
                        <div class="col-9 col-lg-12 text-left text-lg-center pr-3 pt-1">
                          <p class="mb-0 new-text-blue tight-line-p">{{$t("message.myapge_regist_accept_certificate")}}</p>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 d-lg-none mypage-title-row text-center pt-2" style="margin-top: 1.4rem !important; margin-bottom: 1rem !important;">
            <h5>{{ $t("message.consult") }} </h5>
          </div>

          <div class="col-12 col-lg-4 mypage-row">
            <div class="row" style="height: 100%;">
              <div class="col-6 d-none  align-items-center mypage-row-columns-title d-lg-flex justify-content-center mypage-row-columns-border">
                <h4 class="mb-0">
                {{ $t("message.consult") }}
                </h4>
              </div>
              <div class="col-12 col-lg-6 d-none d-lg-block mypage-row-columns-border mypage-row-columns-end-all mypage-row-columns-end-bottom px-0 ">
                <div class="col-12 pl-2 ">
                  <b-icon class="h5 mb-0 mt-2" @click='showInfoModal' icon="question-circle" style='color: gray'></b-icon>
                </div>
                <div @click='lineModal = true'>
                  <div class="col-12 text-center">
                    <b-img class='h40-icon' src="../../assets/mypage/learning-consultation.svg"/>
                  </div>
                  <div class="col-12 text-center pt-2">
                    <p class="mb-0 new-text-blue tight-line-p">{{$t("message.mypage_consultaion_service")}}</p>
                  </div>
                </div>
              </div>
              <div class="col-12 d-block d-lg-none mypage-row-columns-border mypage-row-columns-end-all px-0 ">
                <div class="row my-2">
                  <div class="col-2 pl-4">
                    <b-icon class="h5 mb-0 mt-2" @click='showInfoModal("message.title_help", "message.service_menu_help")' icon="question-circle" style='color: gray'></b-icon>
                  </div>
                  <div @click='lineModal = true'>
                    <div class="col-2 text-center">
                      <b-img class='h40-icon' src="../../assets/mypage/learning-consultation.svg"/>
                    </div>
                    <div class="col-7 text-center pt-2 mt-1">
                      <p class="mb-0 new-text-blue tight-line-p text-center">{{$t("message.consultaion_service")}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row pt-4 mb-2">
          <div class="col-12 py-2">
            <p class="article_title mb-12 mypage_news-text"><b>{{$t("message.news_title")}}</b></p>
            <b-card class="text-right">
              <ul class="px-0">
                <li class="pb-2 news-li shortcut text-left" v-for="(n, index) in 5"  :key="index" >
                  <router-link v-if="news_list['news'][index] != undefined" :to="'./news/' + news_list['news'][index]['id']">
                    <span class="mgr-10 mypage_news-text" style="display: inline;">{{format_day_news(news_list['news'][index])}}</span><br>
                    <p v-html="format_news(news_list['news'][index])" class="mypage_news-text ml-3" style="display: inline"></p>
                  </router-link>
                </li>
              </ul>
              <router-link :to="'./news'">
                <b-button class="more mypage_news-text">{{$t("message.more_look")}}</b-button>
              </router-link>
            </b-card>
          </div>
        </div>

        <div class="row fixed-bottom d-lg-none mypage-fotter">
          <div class="col-4 mypage-fotter-columns px-0">
            <div class="col-12 mt-2">
              <div class="row">
                <div class="col-3 text-center">
                  <b-img src="../../assets/mypage/Scheduled-test-date.svg" style='width: 30px;'/>
                </div>
                <div class="col-9 px-1">
                  <small class="pl-2 mobile-small">{{$t("message.industry_id_" + memberInfo.current_industry)}}{{$t("message.of_exam_day")}} </small>
                </div>
              </div>
            </div>
            <div class="col-12 text-center py-2">
              <p class="mb-0"><b>{{ format_exam_day() }}</b></p>
            </div>
          </div>
          <div class="col-4 mypage-fotter-columns px-0">
            <div class="col-12 mt-2">
              <div class="row">
                <div class="col-3 pl-1 text-center">
                  <b-img src="../../assets/mypage/pass-rate.svg" style='width: 30px;'/>
                </div>
                <div class="col-9 pl-0 pt-2">
                  <small class="pl-1 mobile-small">{{$t("message.estimated_pass_rate")}} </small>
                </div>
              </div>
            </div>
            <div class="col-12 text-center py-2">
              <p class="mb-0"><b>{{pass_rate}}%</b></p>
            </div>
          </div>
          <div class="col-4 mypage-fotter-columns px-0">
            <div class="col-12 mt-2">
              <div class="row">
                <div class="col-3 pl-1 text-center">
                  <b-img src="../../assets/mypage/Average-score.svg" style='width: 30px;'/>
                </div>
                <div class="col-9 pl-0">
                  <small class="pl-1 mobile-small">{{$t("message.your_ave_score_fotter")}} </small>
                </div>
              </div>
            </div>
            <div class="col-12 text-center py-2">
              <p class="mb-0"><b>{{ave_score + $t("message.score")}}</b></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <line-modal ref="line" :lineModal="lineModal"></line-modal>
    <info-modal ref="info"></info-modal>

    <div id="footer_area" class="">
    <div class="footer_area_inner">
      <div class="inquiry_btn">
        <pc>

          <div class="chase-btn pc">
            <div class=""><a href="https://www.instagram.com/aelu_mieruka/"><img class="" src="partner/img/Instagram_Glyph_Gradient_RGB.png" alt="" /></a></div>
          </div>
        </pc>
        <sp>

          <div class="chase-btn sp"> <a href="https://www.instagram.com/aelu_mieruka/"><img class="" src="partner/img/Instagram_Glyph_Gradient_RGB.png" alt="" /></a></div>
        </sp>
      </div>
    </div>
    <div class="footer_area_inner">
      <a class="inquiry_btn" href="">
        <pc>
          <div class="chase-btn2 pc">
            <div class=""><a href="https://www.facebook.com/aelu.mieruka"><img class="" src="partner/img/f_logo_RGB-Blue_512.png" alt="" /></a></div>
          </div>
        </pc>
        <sp>
            <div class="white-space"></div>
          <div class="chase-btn2 sp"> <a href="https://www.facebook.com/aelu.mieruka"><img class="" src="partner/img/f_logo_RGB-Blue_512.png" alt="" /></a></div>
        </sp>
      </a>
    </div>

    </div>


  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import axios from 'axios';
import LineModal from "@/components/User/Session/LineModal";
import InfoModal from "@/components/InfoModal"
export default {
  components: {
    LineModal,
    InfoModal
  },
  data () {
    return {
      lineModal: false,
      exam_day: true,
      aim_rate: 85,
      aim_score: 85,
      examinations: [],
      idToken: localStorage.idToken,
      ave_score: 0,
      pass_rate: 0,
      news_list: [],
      occupation: undefined,
      examination_day: '',
      exam: {},
      is_announce: false,
      options: [],
      select_industry: null,
      industry_placeholder: this.$i18n.t('message.select_ouccupation')
    }
  },
  methods: {
    makeOccupation(){
      this.options = []
      this.occupation = this.memberInfo.current_industry
      var interested_list = []
      if (this.memberInfo.interested_list != [] || this.memberInfo.interested_list != undefined){
        interested_list = this.memberInfo.interested_industry.toString().split(',')
      }
      for(var item of interested_list){
        this.options.push({value: item, text: this.$i18n.t('message.industry_id_' + item)})
      }
    },
    toJobMypage() {
      if(this.memberInfo.accept_number == null && this.memberInfo.accept_image_url == null) {
        this.$swal.fire(
            "合格しないと利用できません",
            "まずは試験を勉強して合格しましょう",
            "warning",
        )
        return
      } else if(this.memberInfo.self_pr == null && this.memberInfo.name_kana == null) {
        this.$swal.fire(
            "履歴書を作成しましょう",
            "履歴書を作成したのちに利用できます",
            "warning",
        )
        return
      } else {
        this.$router.push('/job_mypage')
      }
    },
    format_industry(industry_id){
      console.log(industry_id)
    },
    showInfoModal(title='message.sample_title', description='message.sample_description'){
      this.$refs.info.showModal(this.$i18n.t(title), this.$i18n.t(description))
    },
    format_exam_day(){
      if(this.exam_day){
         moment.locale("ja", {
           weekdays: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
           weekdaysShort: ["日", "月", "火", "水", "木", "金", "土"]
         });
        return moment(this.examination_day).format("MM/DD (ddd)");
      }else{
        return "-"
      }
    },
    format_news(news){
      if(news != undefined){
        if(news.industry_id != null){
          return '[' + this.$i18n.t('message.industry_id_' + news.industry_id) + '] ' + news['title']
        }
        else{
          return news['title']
        }
      }
      return ""
    },
    fetch_news: function() {
      var lang = ''
      if(this.language == 'kh'){
        lang = 'km'
      }else if(this.language == 'lk'){
        lang = 'si'
      }else{
        lang = this.language
      }
      axios
        .get(process.env.VUE_APP_API + "/news",{headers: {'Authorization': 'Bearer ' + this.idToken},params: {
            industry_id: this.memberInfo.current_industry,
            lang: lang
          }})
        .then(response => {
          console.log('this is response news',response.data)
          this.news_list = response.data
        }).catch(error => {
          console.log('this is error', error)
        })
    },
    async getAnyinfo(){
      await setTimeout(() => {}, 1000)
      await axios
        .get(process.env.VUE_APP_API + "/trial_examination",{headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.examinations = response.data
        }).catch(error => {
          console.log('this is error', error)
        })
        var score = 0
        this.examinations.forEach(function(examination){
          score += examination.results
        })
        if(this.examinations.length != 0){
          this.ave_score = Math.floor(score / this.examinations.length)
          this.pass_rate = Math.floor( score / this.examinations.length / 85 * 100)
        }else{
          this.ave_score = 0
          this.pass_rate = 0
        }
        this.occupation = this.memberInfo.current_industry

      await axios
        .get(process.env.VUE_APP_API + "/examinations",{headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.exams = response.data.examinations
          if(this.exams.length != 0) {
            var t = this.format_day(this.exams[0].date)
            const diff = moment(t).diff(moment())
            if(diff > 0) {
              this.exam = this.exams[0]
              this.exam_day = true
              this.examination_day = this.format_day(this.exam.date)
            } else {
              this.examination_day = this.$i18n.t('message.no_examination')
              this.exam_day = false
              this.exam = ""
            }
            this.exams.forEach(ex => {
              var d = moment(ex.announce_date)
              if(this.is_announce == false) {
                this.is_announce = d.isAfter(moment())
              }
            })
          } else {
            this.examination_day = this.$i18n.t('message.no_examination')
            this.exam_day = false
            this.exam = ""
          }

        }).catch(error => {
          console.log('this is error', error)
        })

    }
  },
  async mounted() {
    await this.getAnyinfo()
    console.log(this.memberInfo)
    await axios
      .get(process.env.VUE_APP_API + "/users/" + this.memberInfo.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        var u = response.data
        this.occupation = u.current_industry
        if(u.status == "associate_member") {
          this.$router.push('./createUser')
        }
      }).catch(error => {
        console.log('this is error', error)
      })

    this.fetch_news()
    this.makeOccupation()
    this.$store.commit('setLoading', false)

  },
  computed: {
    ...mapState({
        memberInfo: state => state.user.user,
        language: state => state.language,
        outh: state => state.user.outh
    })
  },
  watch:{
    async memberInfo(val){
      this.occupation = val.current_industry
      await this.getAnyinfo()
    },
    language(){
      this.examination_day = this.$i18n.t('message.no_examination')

      this.fetch_news()
    },
    select_industry(){
      if( this.select_industry != this.memberInfo.current_industry && this.select_industry != null){
        axios
        .patch(process.env.VUE_APP_API + "/users/" + this.memberInfo.id,{user: {current_industry: this.select_industry}},{headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.$store.commit('user/setOccupation', this.select_industry)
          this.makeOccupation()
        }).catch(error => {
          console.log('this is error', error)
        })
      }
    }
  }


}
</script>

<style scoped lang="scss">
.mypage_news-text{
  color: gray;
}

.news-li{
  list-style: none;
  a {
    text-decoration: none;
  }
}

.mb-12{
  margin-bottom: 12px;
}
.more{
  background: #FFFFFF;
  color: gray;
  border: #FFFFFF;
}

.small{
  display:block;
  line-height: 0.85rem;
}

.card{
  border: none;
}

@media (min-width: 991.98px) {
  .col-lg-20 {
    flex: 0 0 20%;
    max-width: 20%;
  }
}

@media (max-width: 991.98px) {
  .img-caption {
    margin-top: 0px !important;
  }
  .mt-3 {
    margin-top: 0px !important;
  }
  .line-title {
    font-size: 20px;
  }
  .line-desc {
    font-size: 13px;
  }
  .col-lg-20 {
    position: relative;
    width: 100%;
  }
}
.h60-icon {
  width: 80px;
}
.h40-icon {
  width: 60px;
}
#footer_area{position: fixed;
  bottom:50%;
  right: 1%;
  vertical-align: top;}

@keyframes horizontal {
    0% { transform:translateX( -3px); }
  100% { transform:translateX(  0px); }
}
@keyframes vertical {
    0% { transform:translateY(-10px); }
  100% { transform:translateY(  0px); }
}

.chace-txt{
margin-left: 10px;
    font-size: 14px;-webkit-writing-mode: vertical-rl;
  -ms-writing-mode: tb-rl;
  writing-mode: vertical-rl;animation: vertical 1s ease-in-out infinite alternate;color: #000}

.chase-btn {padding: 0 0 15% 0

}

.chase-btn img {
  width:45px;
    transition: all .3s ease 0s;
}

.chase-btn img:hover {
  cursor: pointer;
	transform: scale(1.2);
}



.chase-btn2 {

}

.chase-btn2 img {
  width: 45px;
    transition: all .3s ease 0s;
}

.chase-btn2 img:hover {
  cursor: pointer;
	transform: scale(1.2);
}

.sp {
  display: none
}

.pc {
  display: block
}

.br-sp {
  display: none;
}

.br-pc {
  display: block;
}


.br-pc1 {
  display: block;
}


/*下から上にフェードイン*/

.down-to-top {
  opacity: 0.1;
  transform: translateY(80px);
  transition: all 1s;
}

.down-to-top.scrollin {
  opacity: 1;
  transform: translateY(0);
}

@media only screen and (max-width: 767px) {
.pc {
  display: none;
}
}

@media only screen and (max-width: 480px) {
  .pc {
    display: none
  }
  .sp {
    display: block
  }
  .sm-w50 {
    width: 42%;
  }
}


#footer_area{position: fixed;
  bottom:50%;
  right: 1%;
  vertical-align: top;}

.chace-txt{
margin-left: 10px;
    font-size: 14px;-webkit-writing-mode: vertical-rl;
  -ms-writing-mode: tb-rl;
  writing-mode: vertical-rl;animation: vertical 1s ease-in-out infinite alternate;color: #000}

.chase-btn {padding: 0 0 15% 0

}

.chase-btn img {
  width:45px;
    transition: all .3s ease 0s;
}

.chase-btn img:hover {
  cursor: pointer;
	transform: scale(1.2);
}



.chase-btn2 {

}

.chase-btn2 img {
  width: 45px;
    transition: all .3s ease 0s;
}

.chase-btn2 img:hover {
  cursor: pointer;
	transform: scale(1.2);
}

.sp {
  display: none
}

.pc {
  display: block
}

.br-sp {
  display: none;
}

.br-pc {
  display: block;
}


.br-pc1 {
  display: block;
}

@media only screen and (max-width: 992px) {
.chase-btn {
  position: fixed;
  bottom:95px;
  left:15px;
  padding-bottom: 0;
  vertical-align: top;
  z-index: 2
}

.chase-btn img {
  width:45px;
    transition: all .3s ease 0s;
}

.chase-btn img:hover {

}



.chase-btn2 {
  position: fixed;
  bottom:95px;
  left: 65px;
  vertical-align: top;
  z-index: 1
}

.chase-btn2 img {
  width: 45px;
    transition: all .3s ease 0s;
}

.br-pc1 {
  display:none;
}
  
  .sp {
    display: block
  }
  .pc {
    display: none
  }

}


</style>
